import { render, staticRenderFns } from "./PageSizer.vue?vue&type=template&id=2a449012&"
import script from "./PageSizer.vue?vue&type=script&lang=js&"
export * from "./PageSizer.vue?vue&type=script&lang=js&"
import style0 from "./PageSizer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports